// Consultation/ConsultationConfigDesc.tsx

import React from 'react';
import {SxProps, Theme} from '@mui/system';
import {getConsultationTypeLabel} from 'Locale/ruMap';
import {IConsultation} from '../../Types/psychology/consultation';
import {FR} from "WideLayout/Layouts";

interface ConsultationConfigDescProps {
    config: IConsultation['config'];
    language?: IConsultation['language'];
    sx?: SxProps<Theme>;
    className?: string;
}

const ConsultationConfigDesc: React.FC<ConsultationConfigDescProps> = ({
                                                                           config,
                                                                           language,
                                                                           sx,
                                                                           className,
                                                                       }) => {
    const descriptions = [];

    if (config.type) {
        descriptions.push(`${getConsultationTypeLabel(config.type.name)}`);
    }
    if (config.duration && config.duration.value) {
        descriptions.push(`${config.duration.value} минут`);
    }
    if (config.is_supervision) {
        descriptions.push('супервизия');
    }
    if (config.is_online) {
        descriptions.push('онлайн');
    }
    if (language && language.value) {
        descriptions.push(`${language.value}`);
    }

    return (
        <FR sx={sx} cls={className}>
            {descriptions.join(' ')}
        </FR>
    );
};

export default ConsultationConfigDesc;
